export default __webpack_public_path__ + "static/media/arrDown.51ba0a48.svg";